import { Stack } from '@superdispatch/ui';
import { TextBox } from '@superdispatch/ui-lab';
import {
  BusinessHoursRowDTO,
  BusinessHoursType,
  formatBusinessHours,
} from 'shared/utils/businessHoursDisplay';

export interface OfferBusinessHoursProps {
  businessHoursType?: BusinessHoursType | null;
  businessHours?: BusinessHoursRowDTO[] | null;
}

export function OfferBusinessHours({
  businessHoursType,
  businessHours,
}: OfferBusinessHoursProps) {
  const lines = formatBusinessHours(businessHoursType, businessHours);

  if (lines.length === 0) {
    return null;
  }

  return (
    <Stack space="none">
      {lines.map((line) => (
        <TextBox key={line} color="secondary">
          {line}
        </TextBox>
      ))}
    </Stack>
  );
}
